import { axiosInstance } from "../../../axios/axiosInstance";

const API_SERVICE_PROVIDER_APPOINTMENTS_URL = "organization/orders";
const API_SERVICE_PROVIDER_APPOINTMENTS_MODULE_LIST_URL =
  API_SERVICE_PROVIDER_APPOINTMENTS_URL + "/appointment_list";
const API_CREATE_SERVICE_PROVIDER_APPOINTMENTS_MODULE_URL =
  API_SERVICE_PROVIDER_APPOINTMENTS_URL + "/create";
const API_CHECK_SERVICE_AVAILABILITY_URL = "organization/services/check-service-availability";
const API_CHECK_STAFF_AVAILABILITY_URL = "organization/user-management/check-service-provider-availability";
const API_GET_SERVICE_PROVIDER_APPOINTMENTS_INFO_BY_ID_URL =
  API_SERVICE_PROVIDER_APPOINTMENTS_URL + "/view";
const API_UPDATE_SERVICE_PROVIDER_APPOINTMENTS_MODULE_ORDER_STATUS_URL =
  API_SERVICE_PROVIDER_APPOINTMENTS_URL + "/update-order-status";
const API_UPLOAD_SERVICE_PROVIDER_APPOINTMENT_MODULE_CUSTOMER_DOCUMENTS_URL =
  API_SERVICE_PROVIDER_APPOINTMENTS_URL + "/upload-documents";
const API_GET_AVAILABLE_STAFF_FOR_SERVICE_PROVIDER_APPOINTMENTS_MODULE_URL =
  API_SERVICE_PROVIDER_APPOINTMENTS_URL + "/available-staff";
const API_COMPLETE_APPOINTMENT_MODULE_URL =
  API_SERVICE_PROVIDER_APPOINTMENTS_URL + "/complete";
const API_CREATE_SERVICE_INFO_MODULE_URL =
  API_SERVICE_PROVIDER_APPOINTMENTS_URL + "/add-extra-services-to-order";
const API_UPDATE_SERVICE_INFO_MODULE_URL =
  API_SERVICE_PROVIDER_APPOINTMENTS_URL + "/update-extra-services-in-order";
const API_DELETE_SERVICE_INFO_MODULE_URL =
  API_SERVICE_PROVIDER_APPOINTMENTS_URL + "/remove-extra-services-from-order";
const API_UPDATE_PACKAGE_SERVICE_STATUS_URL =
  API_SERVICE_PROVIDER_APPOINTMENTS_URL + "/update-service-status";

export const getServiceProviderAppointments = (dataToBeSent) => {
  return axiosInstance.get(
    `${API_SERVICE_PROVIDER_APPOINTMENTS_MODULE_LIST_URL}?page=${
      dataToBeSent?.page || ""
    }&limit=${dataToBeSent?.limit || ""}&search=${
      dataToBeSent?.search || ""
    }&filters[order_status]=${
      dataToBeSent?.order_status || ""
    }&filters[order_type]=${
      dataToBeSent?.order_type || ""
    }&filters[service_id]=${
      dataToBeSent?.service || ""
    }&filters[service_provider_id]=${dataToBeSent?.staff || ""}&filters[role]=${
      dataToBeSent?.staffType || ""
    }&time_unit=${dataToBeSent?.time_unit || ""}&filters[service_status]=${
      dataToBeSent?.service_status || ""
    }&filters[service_provider_status]=${
      dataToBeSent?.service_provider_status || ""
    }&filters[is_payment_completed]=${
      dataToBeSent?.is_payment_completed || ""
    }&t=${new Date().getTime()}&filters[customer_id]=${dataToBeSent?.customer_id || ""}`
  );
};

export const createServiceProviderAppointment = (dataToBeSent) => {
  return axiosInstance.post(
    API_CREATE_SERVICE_PROVIDER_APPOINTMENTS_MODULE_URL,
    dataToBeSent
  );
};

export const checkServiceAvailability = (dataToBeSent) => {
  return axiosInstance.post(API_CHECK_SERVICE_AVAILABILITY_URL, dataToBeSent);
};

export const checkStaffAvailability = (dataToBeSent) => {
  return axiosInstance.post(API_CHECK_STAFF_AVAILABILITY_URL, dataToBeSent);
};

export const createServiceInfo = ({ selectedAppointmentsInfoId, ...rest }) => {
  return axiosInstance.post(
    `${API_CREATE_SERVICE_INFO_MODULE_URL}/${selectedAppointmentsInfoId}`,
    rest
  );
};

export const deleteServiceInfo = ({ selectedAppointmentsInfoId, ...rest }) => {
  return axiosInstance.post(
    `${API_DELETE_SERVICE_INFO_MODULE_URL}/${selectedAppointmentsInfoId}`,
    rest
  );
};

export const updateServiceInfo = ({ selectedAppointmentsInfoId, ...rest }) => {
  return axiosInstance.post(
    `${API_UPDATE_SERVICE_INFO_MODULE_URL}/${selectedAppointmentsInfoId}`,
    rest
  );
};

export const getServiceProviderAppointmentsInfoById = (dataToBeSent) => {
  return axiosInstance.get(
    API_GET_SERVICE_PROVIDER_APPOINTMENTS_INFO_BY_ID_URL +
      "/" +
      dataToBeSent?.selectedAppointmentsInfoId
  );
};

export const updateServiceProviderAppointmentOrderStatus = ({
  selectedServiceProviderAppointmentId,
  ...rest
}) => {
  return axiosInstance.post(
    API_UPDATE_SERVICE_PROVIDER_APPOINTMENTS_MODULE_ORDER_STATUS_URL +
      "/" +
      selectedServiceProviderAppointmentId,
    { ...rest }
  );
};

export const uploadServiceProviderAppointmentCustomerDocuments = ({
  orderId,
  ...rest
}) => {
  return axiosInstance.post(
    API_UPLOAD_SERVICE_PROVIDER_APPOINTMENT_MODULE_CUSTOMER_DOCUMENTS_URL +
      "/" +
      orderId,
    { ...rest }
  );
};

export const getAvailableStaffForAppointment = ({ orderId, service_id }) => {
  return axiosInstance.post(
    API_GET_AVAILABLE_STAFF_FOR_SERVICE_PROVIDER_APPOINTMENTS_MODULE_URL +
      "/" +
      orderId,
    { service_id }
  );
};

export const completeAppointment = (dataToBeSent) => {
  return axiosInstance.post(
    API_COMPLETE_APPOINTMENT_MODULE_URL +
      "/" +
      dataToBeSent?.selectedAppointmentsInfoId
  );
};

export const updatePackageServiceStatus = ({
  selectedAppointmentsInfoId,
  ...rest
}) => {
  return axiosInstance.post(
    API_UPDATE_PACKAGE_SERVICE_STATUS_URL + "/" + selectedAppointmentsInfoId,
    { ...rest }
  );
};
